import type { ColumnDef } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';
import { AnomalyChip } from '@/components/ui/AnomalyChip';
import { SortIcons } from '../FileListTable/SortIcons';

export const AnomalyColumn: ColumnDef<File> = {
  id: 'anomalies',
  accessorFn: (row) => row.anomalies,
  header: ({ column }) => (
    <button
      onClick={() => column.toggleSorting()}
      className="flex w-full items-center justify-center gap-1"
    >
      Anomalies
      <SortIcons sortDirection={column.getIsSorted()} />
    </button>
  ),
  cell: (props) => <AnomalyChip value={Number(props.getValue())} />,
  enableSorting: true,
  size: 100,
  minSize: 100,
};
